<script lang="ts">
	import { cn } from '$lib/utils/class-merge';
	import type { Snippet } from 'svelte';

	type Props = {
		children: Snippet;
		className?: string;
	};

	let { children, className = '' }: Props = $props();
</script>

<div class={cn('relative rounded-base bg-two px-5 md:px-8 py-5', className)}>
	{#if children}
		{@render children()}
	{/if}
</div>
